import { Modal, Button, Typography } from "antd";
import styled from "styled-components";
import { PaymentErrorIcon } from "../../../../assets/PaymentIcon";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 24px;
    padding: 24px;
    min-width: 580px;
    min-height:312px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 0;
  }

  .ant-modal-title {
    font-size: 24px;
    font-weight: 500;
    color: #191114;
  }

  .ant-modal-body {
    width:100%;
    margin-top: 16px;
    padding: 0;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction:column;
    text-align:center;
    gap:18px;
  }

  .ant-modal-footer {
    border-top: none;
    padding-top: 32px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
`;

const OKButton = styled(Button)`
 width: 520px;
  height: 56px;
  border-radius: 8px;
  font-weight: 500;
  background-color: #1859ff;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background-color: #1859ff !important;
    opacity: 0.9;
  }
`;
const AutoPaymentModalError = ({ open, onCancel, errorMessage }) => {

  const {t} = useTranslation();

  return (
     <StyledModal
       open={open}
       onCancel={onCancel}
       footer={null}
       centered
       closable
    //    title="Unable to Switch!"
       width={512}
     >
        <PaymentErrorIcon/>
        <Text style={{ fontSize: 24, lineHeight: "34px", color: "#191114",fontWeight:500 }}>{t('unable_switch')}</Text>
       <Text style={{ fontSize: 16, lineHeight: "22px", color: "#191114",fontWeight:300 }}>
         {errorMessage}
       </Text>
 
       <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 32 }}>
         <OKButton type="primary" onClick={onCancel}>
           {t('ok')}
         </OKButton>
       </div>
     </StyledModal>
   );
}

export default AutoPaymentModalError
